import React from "react";

interface Props
    extends React.InputHTMLAttributes<HTMLInputElement> {
    label: string;
    icon?: React.ElementType;
    error?: string;
}

const InputField = ({
    label,
    icon: Icon,
    required = false,
    error,
    type = "text",
    className = "",
    ...props
}: Props) => {
    const inputId = props.id || props.name;

    return (
        <div>
            <label
                htmlFor={inputId}
                className="flex items-center text-sm font-medium text-gray-700 mb-2"
            >
                {Icon && (
                    <Icon
                        size={16}
                        className="me-2 text-[#b3d130]"
                    />
                )}

                {label}

                {required && (
                    <span className="text-red-500 ms-1">
                        *
                    </span>
                )}
            </label>

            <input
                id={inputId}
                type={type}
                required={required}
                aria-invalid={!!error}
                {...props}
                className={`
          w-full px-4 py-3 border rounded-xl
          focus:border-[#b3d130]
          focus:outline-none
          focus:ring-2
          focus:ring-[#b3d130]/20
          transition-all duration-300
          ${error
                        ? "border-red-500 bg-red-50"
                        : "border-gray-300"
                    }
          ${props.readOnly
                        ? "bg-gray-50 cursor-not-allowed"
                        : ""
                    }
          ${className}
        `}
            />

            {error && (
                <p className="text-xs text-red-500 mt-1 flex items-center gap-1">
                    <span>⚠️</span>
                    {error}
                </p>
            )}
        </div>
    );
};

export default InputField;